import { copyToClipboard } from "@core/shared/utils";
import { successToast } from "@design-system/components/toast";
import { loginBrowserHelpAtom } from "@framework/auth/atoms";
import {
  buildChromeIntentUrl,
  isAndroidUserAgent,
  toSecurePageUrl,
} from "@framework/auth/browser-environment";
import { trans } from "@mongez/localization";

/**
 * State and actions of the "this browser can't sign in" advice panel.
 *
 * @example
 * const { reason, chromeIntentUrl, copyPageLink } = useLoginBrowserHelp();
 */
export function useLoginBrowserHelp() {
  const { reason } = loginBrowserHelpAtom.useValue();
  const isBrowser = typeof window !== "undefined";
  const pageUrl = isBrowser ? window.location.href : "";
  const userAgent = isBrowser ? window.navigator.userAgent : "";

  const chromeIntentUrl =
    reason === "inAppBrowser" && isAndroidUserAgent(userAgent)
      ? buildChromeIntentUrl(pageUrl)
      : undefined;
  const secureUrl =
    reason === "insecureConnection" ? toSecurePageUrl(pageUrl) : undefined;

  const copyPageLink = () => {
    copyToClipboard(toSecurePageUrl(pageUrl) || pageUrl);
    successToast(trans("auth.linkCopied"));
  };

  const dismiss = () => loginBrowserHelpAtom.update({ reason: null });

  return { reason, chromeIntentUrl, secureUrl, copyPageLink, dismiss };
}
